import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { OPEN_SETTINGS_EVENT, readConsent, saveConsent } from "@/lib/consent";

export function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [configuring, setConfiguring] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const c = readConsent();
    if (!c) setOpen(true);
    const reopen = () => {
      const cur = readConsent();
      setAnalytics(cur?.analytics ?? false);
      setMarketing(cur?.marketing ?? false);
      setConfiguring(true);
      setOpen(true);
    };
    window.addEventListener(OPEN_SETTINGS_EVENT, reopen);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, reopen);
  }, []);

  if (!open) return null;

  const decide = (a: boolean, m: boolean) => {
    saveConsent(a, m);
    setOpen(false);
    setConfiguring(false);
  };

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-title"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-card p-4 shadow-2xl md:inset-x-auto md:bottom-6 md:left-6 md:max-w-lg md:rounded-2xl md:border"
    >
      <h2 id="cookie-title" className="font-display text-base font-semibold text-foreground">
        Utilizamos cookies
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Usamos cookies essenciais para o site funcionar e, apenas com a sua autorização, cookies de
        estatística (Google Analytics) e de marketing (Meta/Facebook e Google) para medir visitas e
        anúncios. Pode alterar a sua escolha a qualquer momento em “Definições de cookies”, no rodapé.{" "}
        <Link to="/politica-de-cookies" className="underline hover:text-primary">Política de Cookies</Link>
      </p>

      {configuring && (
        <div className="mt-4 space-y-3 text-sm">
          <label className="flex items-start gap-3">
            <input type="checkbox" checked disabled className="mt-1" />
            <span><strong className="text-foreground">Essenciais</strong> — necessários ao funcionamento (sempre ativos).</span>
          </label>
          <label className="flex items-start gap-3">
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="mt-1 accent-[color:var(--color-primary)]" />
            <span><strong className="text-foreground">Estatística</strong> — Google Analytics / Tag Manager, para perceber como o site é usado.</span>
          </label>
          <label className="flex items-start gap-3">
            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-1 accent-[color:var(--color-primary)]" />
            <span><strong className="text-foreground">Marketing</strong> — Meta Pixel, API de Conversões e Google Ads, para medir anúncios.</span>
          </label>
        </div>
      )}

      <div className="mt-4 grid grid-cols-3 gap-2">
        <Button variant="outline" onClick={() => decide(false, false)}>Rejeitar</Button>
        {configuring ? (
          <Button variant="outline" onClick={() => decide(analytics, marketing)}>Guardar</Button>
        ) : (
          <Button variant="outline" onClick={() => setConfiguring(true)}>Configurar</Button>
        )}
        <Button variant="outline" onClick={() => decide(true, true)}>Aceitar</Button>
      </div>
    </div>
  );
}
